import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CustomerSelectorComponent } from './customer-selector.component';

@Component({
    selector: 'wrt-routed-create',
    template: '',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class RoutedCustomerSelectorComponent implements OnInit {
  constructor(private dialog: MatDialog) {}

  ngOnInit(): void {
    this._openDialog();
  }

  _openDialog() {
    this.dialog.open(CustomerSelectorComponent, {
      width: '500px',
      panelClass: ['no-padding'],
    });
  }
}
